import React, { memo } from 'react';

import Network from 'components/Listeners/Network/container';
import Visibility from 'components/Listeners/Visibility/container';
import Devices from 'components/Listeners/Devices/container';
import { isCallUrl } from 'utils/url';

export default memo(() => (
    <>
        <Network />
        <Visibility />
        {isCallUrl() && <Devices />}
    </>
));
